import React, {useContext, useEffect, useState} from 'react';
import {Link} from 'react-router-dom';
import {FaFolder} from 'react-icons/fa';
import {DashboardButtonsComponent} from '../../dashboard/component/DashboardComponent';
import NaviBackForwardComponent from './NaviBackForwardComponent';
import FullScreenButtonsComponent from './FullScreenButtonsComponent';
import ThemeButtonComponent from './ThemeButtonComponent';
import FontSizeButtonsComponent from './FontSizeButtonsComponent';
import CommonSessionComponent from './CommonSessionComponent';
import ChordsModeButtonComponent from './ChordsModeButtonComponent';
import ToggleAllSongsExpansionButtonComponent from './ToggleAllSongsExpansionButtonComponent';
import SongsViewSwitcherComponent from './SongsViewSwitcherComponent';
import HideChordsButtonComponent from './HideChordsButtonComponent';
import ToggleSongExpansionButtonComponent from './ToggleSongExpansionButtonComponent';
import ToggleLyricSeparatorButtonComponent from './ToggleLyricSeparatorButtonComponent';
import PresentationButtonComponent from './PresentationButtonComponent';
import PresentationPilotButtonComponent from './PresentationPilotButtonComponent';
import BackupComponent from '../../song/backup/components/BackupComponent';
import ExportButtonComponent from '../../song/components/ExportButtonComponents';
import {AppCtx} from '../../../AppCtx';
import {useWorkspaceReadOnly} from '../../../shared/hooks/useWorkspaceReadOnly';
import './SearchToolsMenu.css';

const Group = ({name, children}) => <section className="search-tools-group" aria-label={name}>
  <h2>{name}</h2><div className="search-tools-actions">{children}</div>
</section>;

const phoneQuery = '(max-width: 600px)';
const usePhone = () => {
  const [phone, setPhone] = useState(() => window.matchMedia?.(phoneQuery).matches ?? false);
  useEffect(() => {
    const query = window.matchMedia?.(phoneQuery);
    if (!query) return undefined;
    const update = () => setPhone(query.matches);
    query.addEventListener?.('change', update);
    return () => query.removeEventListener?.('change', update);
  }, []);
  return phone;
};

export default function SearchToolsMenu() {
  const readOnly = useWorkspaceReadOnly();
  const {isPresentationControlPanelVisible, isCommonSessionEnabled} = useContext(AppCtx);
  // Screen and pilot sit on top of the group mode, so solo mode has no use for them.
  const showPresentation = process.env.REACT_APP_HOSANNA_DIRECT !== '1' || isCommonSessionEnabled;
  const phone = usePhone();
  // A phone used as a remote needs only the group and projector toggles.
  if (phone && isPresentationControlPanelVisible && process.env.REACT_APP_HOSANNA_DIRECT === '1') {
    return <div className="search-tools-menu search-tools-menu--pilot" role="group" aria-label="Narzędzia pilota">
      <div className="search-tools-actions"><CommonSessionComponent/><PresentationButtonComponent/></div>
    </div>;
  }
  return <div className="search-tools-menu" role="group" aria-label="Narzędzia i nawigacja">
    <Group name="Nawigacja"><DashboardButtonsComponent/><NaviBackForwardComponent/>
      <Link to="/songs" title="Przejdź do katalogów" aria-label="Przejdź do katalogów"><FaFolder/></Link>
    </Group>
    <Group name="Widok"><FullScreenButtonsComponent/><ThemeButtonComponent/><FontSizeButtonsComponent/></Group>
    <Group name="Pieśni"><ChordsModeButtonComponent/><ToggleAllSongsExpansionButtonComponent/>
      {!readOnly && <><SongsViewSwitcherComponent/><HideChordsButtonComponent/>
        <ToggleSongExpansionButtonComponent/><ToggleLyricSeparatorButtonComponent/></>}
    </Group>
    {showPresentation && <Group name="Prezentacja"><PresentationButtonComponent/>{!readOnly && <PresentationPilotButtonComponent/>}</Group>}
    <Group name="Pliki i eksport"><BackupComponent/><ExportButtonComponent/></Group>
    <Group name="Sesja"><CommonSessionComponent/></Group>
  </div>;
}
